import { render, staticRenderFns } from "./EquipmentDetailsContainer.vue?vue&type=template&id=2d520668&"
import script from "./EquipmentDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./EquipmentDetailsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d520668')) {
      api.createRecord('2d520668', component.options)
    } else {
      api.reload('2d520668', component.options)
    }
    module.hot.accept("./EquipmentDetailsContainer.vue?vue&type=template&id=2d520668&", function () {
      api.rerender('2d520668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/EquipmentDetailsContainer.vue"
export default component.exports